export default "__VITE_ASSET__BDDhglfC__"